/** 
 * 登录模块
 *
 * @Author: xujun  
 * @Date: 2019-11-28 17:59:47   
 */
import cookie from "../cookie";
import passport from "./passport";


export default {
    /**
     * 是否登录
     */
    isLogin: function () {
        if (!this.getUserInfo()) {
            return false;
        }

        return true;
    },
    login: function () {
        // 不支持https
        if (document.all && !(<any>window).XMLHttpRequest) {
            window.open('http://exaccount2.eastmoney.com/BroswerUpgrade.html');
            return;
        }

        if (!this.isLogin()) {
            passport.request();

            return false;
        }
        return true;
    },
    /**
     * 获取用户名
     */
    getUserName: function () {
        if (!this.getUserInfo()) {
            return '';
        }

        return (<string[]>(this.getUserInfo()))[2];
    },
    /**
     * 获取用户id
     */
    getUserId: function () {
        if (!this.getUserInfo()) {
            return '';
        }

        return (<string[]>(this.getUserInfo()))[0];
    },
    /**
     * 获取用户信息
     */
    getUserInfo: function () {
        try {
            let pi: any = cookie.get('pi');
            let ut = cookie.get('ut');
            let ct = cookie.get('ct')

            if (!ut || !ct) {
                return false;
            }
            if (!pi) {
                return false;
            }

            var userInfo = pi.split(';');

            return userInfo;
        } catch (error) {
            return false;
        }
    },
    /**
     * 删除用户信息
     */
    deleteUserInfo: function () {
        var arr = ['pi', 'ut', 'ct', 'uidal'];

        for (var i = 0; i < arr.length; i++) {
            cookie.del(arr[i], 'eastmoney.com');
        }
    },
    /**
     * 登出
     */
    logout: function () {
        this.deleteUserInfo();
        window.location.reload();
    }
}